export const en = {
    "alice-skill": "Alice skill",
    "alice-skill-default-name": "New skill",
    "choose-type": "Choose dialog type",
    "new-app": "New application",
    "new-skill": "New skill",
    "new-smart-home": "New smart home",
    "smart-home": "Smart home",
    "smart-home-skill-default-name": "New smart home",
    "synthesize": "Synthesizer",
    "teach-alice": "Teach Alice something new",
    "teach-smart-home": "Teach Alice to control a smart home",
    "teach-synthesizer": "Teach Alice to play your tunes",
    "thereminvox-skill-default-name": "New skill",
    "user-agreement__1": "By creating a dialogue, you accept the terms of the",
    "user-agreement__2": "user agreement",
} as const;
export const ru = {
    "alice-skill": "Навык",
    "alice-skill-default-name": "Новый навык",
    "choose-type": "Выберите тип диалога",
    "new-app": "Новое приложение",
    "new-skill": "Новый навык",
    "new-smart-home": "Новый умный дом",
    "smart-home": "Умный дом",
    "smart-home-skill-default-name": "Новый умный дом",
    "synthesize": "Синтезатор",
    "teach-alice": "Научить Алису чему-нибудь новому",
    "teach-smart-home": "Научить Алису управлять умным домом",
    "teach-synthesizer": "Научить Алису проигрывать ваши мелодии",
    "thereminvox-skill-default-name": "Новый навык",
    "user-agreement__1": "Создавая диалог, вы принимаете условия",
    "user-agreement__2": "пользовательского соглашения",
} as const;
